module.exports = __webpack_public_path__ + "static/media/links.b94a7b37.jpg";